<template>
  <div class="h-100">
    <router-link
      :to="{ name: 'users.show', params: { username: user.username } }"
      class="d-flex flex-column h-100"
    >
      <div class="common-card people-card d-flex flex-column h-100">
        <div class="cover" :style="coverImage"></div>
        <div class="content">
          <div class="people-image" :style="profileImage"></div>
          <div class="actions text-right mb-4">
            <FollowButton
              :isFollowed="user.is_followed"
              :idToFollow="user.id"
              v-if="authUser && authUser.id !== user.id"
              @follow-toggled="followToggled"
            />
          </div>

          <h2 class="text-center font-size-medium font-weight-bold mb-0">
            {{ user.name }}
          </h2>
          <div class="text-center d-flex justify-content-center align-items-center mt-1">
            <p class="font-size-small text-center d-inline mb-0">
              <span class="text-color2">@</span>
              {{ user.username }}
            </p>
            <BaseIcon
              v-if="user && user.is_verified"
              size="xSmall"
              class="verified-wrap font-size-small d-inline ml-1"
            >
              <VerifiedIcon
                class="profile"
              />
            </BaseIcon>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

import variables from '@/mixins/variables'
import { mapState } from 'vuex'

import FollowButton from '@/components/follow/FollowButton'
import BaseIcon from '@/components/common/Icon/BaseIcon.vue'
import VerifiedIcon from '@/components/common/Icon/VerifiedIcon.vue'

export default {
  name: 'UserProfileCard',
  props: ['user'],
  mixins: [variables],
  components: {
    FollowButton,
    BaseIcon,
    VerifiedIcon
  },
  computed: {
    coverImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.cover}')` : `url('${this.noCoverUrl}')`
      }
    },
    profileImage () {
      return {
        backgroundImage: this.user ? `url('${this.user.avatar}')` : `url('${this.noAvatarUrl}')`
      }
    },
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  methods: {
    followToggled (e) {
      this.$emit('follow-toggled', e)
    }
  }
}
</script>

<style lang="scss" scoped>

h2 {
  overflow-wrap: break-word;
}

.content {
  flex-grow: 1
}
.actions {
  min-height: 41px;
}

.verified-wrap {
  display: inline-block;
  height: 20px;
  vertical-align: top;

  ::v-deep {
    .profile {
      height: 20px;
    }
  }
}
</style>
